
import { ediMonitoringStatusCheckboxOption } from "presentation/constant/CheckBox/StaticCheckboxOptions";
import { ediIssueTypeDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { EdiMonitoringConstant } from "presentation/constant/EdiMonitoring/EdiMonitoringConstant";
import { useEdiMonitoringVM } from "presentation/hook/EdiMonitoring/useEdiMonitoringVM";
import { useEdiMonitoringTracked } from "presentation/store/EdiMonitoring/EdiMonitoringProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, GroupCheckboxList, HPHGroupCheckbox, IFieldValue } from "veronica-ui-component/dist/component/core";

const EdiMonitoringSearchForm = () => {
    const [ediMoniState] = useEdiMonitoringTracked();
    const ediMoniVM = useEdiMonitoringVM();
    const EDI_MONI_CONST = EdiMonitoringConstant;
    const { searchCriteria } = ediMoniState;


    const memoChgType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.chargeTypeList?.join(',')}
                fieldValue={searchCriteria?.chargeTypeList}
                fieldLabel={EDI_MONI_CONST.CHARGE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeTypeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={ediMoniState.dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ediMoniVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [EDI_MONI_CONST.CHARGE_TYPE, searchCriteria.chargeTypeList, ediMoniState.dynamicOptions.chargeTypeDropdownOptions, ediMoniVM])

    const memoStatus = useMemo(() =>
        <div className='im-flex-row-item'>
            <HPHGroupCheckbox
                label={EDI_MONI_CONST.STATUS}
                checkboxData={ediMonitoringStatusCheckboxOption}
                selectedValues={searchCriteria.statusList}
                orientation={"horizontal"}
                onChange={(e: (GroupCheckboxList | undefined)[]) => ediMoniVM.onGroupCheckboxChange(e, searchCriteria, "statusList")}
            />
        </div>
        , [EDI_MONI_CONST.STATUS, ediMoniVM, searchCriteria])

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.billToCompList?.join(',')}
                fieldValue={searchCriteria?.billToCompList}
                fieldLabel={EDI_MONI_CONST.BILL_TO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={ediMoniState.dynamicOptions.billToCompDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ediMoniVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [EDI_MONI_CONST.BILL_TO_COMPANY, searchCriteria.billToCompList, ediMoniState.dynamicOptions.billToCompDropdownOptions, ediMoniVM])



    const memoSentDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={EDI_MONI_CONST.SENT_DATE_RANGE}
                width='330px'
                fieldNames={{ startField: "sentDateFrom", endField: "sentDateTo" }}
                dateRange={{ startDate: searchCriteria.sentDateFrom, endDate: searchCriteria.sentDateTo }}
                onDatesChange={ediMoniVM.onDateRangeChange}
            />
        </div>
        , [EDI_MONI_CONST.SENT_DATE_RANGE, searchCriteria.sentDateFrom, searchCriteria.sentDateTo, ediMoniVM.onDateRangeChange])

    // const memoCreatedDateFromTo = useMemo(() =>
    //     <div className='im-flex-row-item'>
    //         <DateRangePickerComponent
    //             label={EDI_MONI_CONST.CREATED_DATE_RANGE}
    //             width='330px'
    //             fieldNames={{startField:"createdDateFrom", endField:"createdDateTo"}}
    //             dateRange={{startDate:searchCriteria.createdDateFrom, endDate:searchCriteria.createdDateTo}}
    //             onDatesChange={ediMoniVM.onDateRangeChange}
    //         />                
    //     </div>
    // , [EDI_MONI_CONST.CREATED_DATE_RANGE, searchCriteria.createdDateFrom, searchCriteria.createdDateTo, ediMoniVM.onDateRangeChange])

    const memoInvCreditNoteNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.invCreditNoteNo || ''}
                fieldValue={searchCriteria.invCreditNoteNo}
                fieldLabel={EDI_MONI_CONST.INV_CR_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'invCreditNoteNo'}
                maxLength={12}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ediMoniVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [EDI_MONI_CONST.INV_CR_NO, searchCriteria.invCreditNoteNo, ediMoniVM])

    const memoIssueType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.issueTypeList?.join(',')}
                fieldValue={searchCriteria?.issueTypeList}
                fieldLabel={EDI_MONI_CONST.ISSUE_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'issueTypeList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={ediIssueTypeDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ediMoniVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [EDI_MONI_CONST.ISSUE_TYPE, searchCriteria.issueTypeList, ediMoniVM])

    const memoIssueBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.issuedByList?.join(',')}
                fieldValue={searchCriteria?.issuedByList}
                fieldLabel={EDI_MONI_CONST.ISSUED_BY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'issuedByList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={ediMoniState.dynamicOptions.issuedByDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ediMoniVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [EDI_MONI_CONST.ISSUED_BY, searchCriteria.issuedByList, ediMoniState.dynamicOptions.issuedByDropdownOptions, ediMoniVM])

    const memoCreatedBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.createdByList?.join(',')}
                fieldValue={searchCriteria?.createdByList}
                fieldLabel={EDI_MONI_CONST.CREATED_BY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'createdByList'}
                maxLength={60}
                isMultipleDropDown={true}
                options={ediMoniState.dynamicOptions.createdByDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    ediMoniVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [EDI_MONI_CONST.CREATED_BY, searchCriteria.createdByList, ediMoniState.dynamicOptions.createdByDropdownOptions, ediMoniVM])

    return <>

        <CriteriaItemContainer>
            {memoStatus}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoChgType}
            {memoBillToCompany}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoInvCreditNoteNo}
            {memoIssueType}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoIssueBy}
            {memoCreatedBy}
        </CriteriaItemContainer>


        <CriteriaItemContainer>
            {memoSentDateFromTo}
        </CriteriaItemContainer>

    </>;
}
export default memo(EdiMonitoringSearchForm);